import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Printer } from "@phosphor-icons/react";
import buildChallanHtml from "@/components/deliveryChallanHtml";

export default function DeliveryChallanButton({ transferId }) {
  const handle = async () => {
    try {
      const { data } = await api.get(`/inventory/transfers/${transferId}/challan`);
      const w = window.open("", "_blank", "width=900,height=1100");
      if (!w) {
        toast.error("Please allow pop-ups to print the challan.");
        return;
      }
      w.document.write(buildChallanHtml(data));
      w.document.close();
    } catch (err) {
      toast.error(formatApiError(err));
    }
  };

  return (
    <button
      type="button"
      onClick={handle}
      data-testid={`challan-${transferId}`}
      title="Print delivery challan"
      className="inline-flex items-center gap-1 px-2 py-1 border border-canvas-line text-[11px] font-mono uppercase tracking-wider hover:border-ink"
    >
      <Printer size={11} weight="bold" />
      Challan
    </button>
  );
}
